import React from 'react';
// 注意: loading.css 位于 public 目录，在 index.html 中已引用

interface AppLoadingProps {
    visible?: boolean;
    text?: string;
    type?: 'full' | 'simple' | 'minimal'; // 不同的骨架屏类型
}

const AppLoading: React.FC<AppLoadingProps> = ({ 
    visible = true, 
    text = '',
    type = 'full' 
}) => {
    if (!visible) return null;

    const renderSkeletonContent = () => {
        switch (type) {
            case 'minimal':
                return (
                    <>
                        <div className="skeleton-content">
                            <div className="skeleton-item skeleton-line"></div>
                            <div className="skeleton-item skeleton-line"></div>
                        </div>
                    </>
                );
            
            case 'simple':
                return (
                    <>
                        <div className="skeleton-header">
                            <div className="skeleton-item skeleton-avatar"></div>
                            <div className="skeleton-header-content">
                                <div className="skeleton-item skeleton-title"></div>
                                <div className="skeleton-item skeleton-subtitle"></div>
                            </div>
                        </div>
                        <div className="skeleton-content">
                            <div className="skeleton-item skeleton-line"></div>
                            <div className="skeleton-item skeleton-line"></div>
                        </div>
                    </>
                );
            
            case 'full':
            default:
                return (
                    <>
                        <div className="skeleton-header">
                            <div className="skeleton-item skeleton-avatar"></div>
                            <div className="skeleton-header-content">
                                <div className="skeleton-item skeleton-title"></div>
                                <div className="skeleton-item skeleton-subtitle"></div>
                            </div>
                        </div>
                        
                        <div className="skeleton-content">
                            <div className="skeleton-item skeleton-line"></div>
                            <div className="skeleton-item skeleton-line"></div>
                            <div className="skeleton-item skeleton-line"></div>
                            <div className="skeleton-item skeleton-line"></div>
                        </div>
                        
                        <div className="skeleton-actions">
                            <div className="skeleton-item skeleton-button"></div>
                            <div className="skeleton-item skeleton-button"></div>
                        </div>
                    </>
                );
        }
    };

    return (
        <div className="loading">
            <div className="loading-content">
                {renderSkeletonContent()}
                <div className="loading-text">{text}</div>
            </div>
        </div>
    );
};

export default AppLoading;